export const DIGITAL_DOCUMENTS = "DIGITAL_DOCUMENTS";
